import { Component, OnInit } from '@angular/core';

import {MatTableModule} from '@angular/material/table';
import { ServerService } from 'src/app/services/server.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-campaign-report',
  templateUrl: './campaign-report.component.html',
  styleUrls: ['./campaign-report.component.scss']
})
export class CampaignReportComponent implements OnInit {
  columns: string[] = ['id', 'report','report_type', 'view_report'];
  show =true
  showComponentLoader = true;
  dataSource = [
    
  ];
  token = localStorage.getItem('token')
  constructor(private serverService:ServerService,
    private _router:Router
  ) { }

  ngOnInit() {
    this.getReport();
  }
  getReport(){
    let url = 'client/reports'
    this.serverService.getReportClient(url,this.token).subscribe((data)=>{
      // console.log(data)
      this.showComponentLoader = false
      this.dataSource = data;
      // this.dataSource = []
    })
  }
  open(url:any){
    // this._router.navigate( window.open(url, '_blank');)
    window.open(url, '_blank');
  }
}
